// i18next-extract-mark-ns-start CoutureServices
import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { isZipcodeCover } from '../../services/zipcode';
import {
  Title, Input as StyledFormInput, frames, margins, tabletThresholdPixels,
  mobileThresholdPixels,
} from './v4/styledComponents';
import { isMultilingual } from '../../../languages';
import MainHowItWorks from './HowItWorks/Main-HowItWorks';
import atHomeIcon from '../../assets/howItWorks/atHome.howItWorks.svg';
import packageIcon from '../../assets/howItWorks/package.howItWorks.svg';

const Container = styled.div`
  margin: ${margins.m15} ${frames.desktop};
  max-width: 1180px;
  width: 100%;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 ${frames.tablet} ${margins.m14};
    width: calc(100% - ${frames.tablet} * 2);
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 0 ${frames.mobile} ${margins.m8};
    width: calc(100% - ${frames.mobile} * 2);
  }
`;

const ZipcodeContainer = styled.div`
  margin: 64px 0;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 48px 0;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 24px 0;
  }
`;
const Label = styled.p`
  font-size: 16px;
  margin: 0;
  text-transform: uppercase;
  font-weight: 700;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 10px;
  }
`;
const FormInput = styled(StyledFormInput)`
  font-size: 16px;
  @media (max-width: ${mobileThresholdPixels}) {
    margin-bottom: 0;
  }
`;
const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: ${mobileThresholdPixels}) {
    align-items: flex-start;
  }
`;
const Subtitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  text-transform: uppercase;
  margin: 0;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 32px;
    line-height: 40px;
  }
`;
const Icon = styled.img`
  width: 48px;
  height: 48px;
  @media (max-width: ${mobileThresholdPixels}) {
    width: 32px;
    height: 32px;
    margin-top: 6px;
  }
`;

function HowItWorksBlock({ isPackage } : {isPackage: boolean}) {
  const { t } = useTranslation('');
  const [zipcode, setZipcode] = useState('');
  const isZipcodeComplete = zipcode.length === 5;

  const renderZipCodeQuestion = () => (
    <ZipcodeContainer>
      <Label>
        {t('Testez votre code postal')}
      </Label>
      <FormInput
        name="zipcode"
        type="number"
        placeholder="ex: 91344"
        onChange={(e) => setZipcode(e.target.value)}
      />
    </ZipcodeContainer>
  );

  const renderSubtitle = () => {
    if (isZipcodeCover(zipcode)) {
      return (
        <SubtitleContainer>
          <Icon src={atHomeIcon} alt="Comment ça marche" />
          <Subtitle>{t('Service à domicile')}</Subtitle>
        </SubtitleContainer>
      );
    }
    return (
      <SubtitleContainer>
        <Icon src={packageIcon} alt="Comment ça marche" />
        <Subtitle>{t('Envoi de colis')}</Subtitle>
      </SubtitleContainer>
    );
  };

  return (
    <Container>
      <Title>{t('Comment ça marche')}</Title>
      {isPackage ? <MainHowItWorks isPackage /> : (
        <>
          {!isMultilingual && renderZipCodeQuestion()}
          {isZipcodeComplete && renderSubtitle()}
          <MainHowItWorks zipcode={zipcode} isZipcodeComplete={isZipcodeComplete} />
        </>
      )}
    </Container>
  );
}

export default HowItWorksBlock;
